import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AppErrors, NotFoundError } from '@fitness-force/models';;
import type { TenantSettingByKey } from '@fitness-force/models';
import { environment } from '@fitness-force/environments';
import { catchError, map, Observable, throwError } from 'rxjs';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';

@Injectable({
  providedIn: 'root'
})
export class AdvancedSettingService {
  private http = inject(HttpClient);
  private router = inject(Router);

  BASE_URL: string = environment.BASE_URL;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };


  getAdvanceSetting(tenantId:number,tentstgKey:string): Observable<TenantSettingByKey>{
    return this.http
      .get(
        environment.BASE_URL + CONST_URL_SEGEMENTS.ADVANCED_SETTING.GET_ADVANCED_SETTING
          .replace('{tenant_id}', tenantId.toString())
          .replace('{setting_key}', tentstgKey),
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getAdvanceSettings(tenantId:number): Observable<TenantSettingByKey>{
    return this.http
      .get(
        environment.BASE_URL + CONST_URL_SEGEMENTS.ADVANCED_SETTING.GET_ADVANCED_SETTINGS
          .replace('{tenant_id}', tenantId.toString()),
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  updateAdvanceSettings(tenantId: number,  data: any) {
    return this.http.put(environment.BASE_URL + CONST_URL_SEGEMENTS.ADVANCED_SETTING.UPDATE_ADVANCED_SETTINGS
      .replace('{tenant_id}', tenantId.toString()),data,this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }
}
